<template>
  <div class="retention-wrapper">
    <div class="section-title">
      <div class="left">
        <i class="el-icon-tickets"></i>
        <span class="title-name">用户管理</span>
      </div>
      <div class="right">
        <el-button @click="setRoles" size="small" v-if="checkPermission(['USER_ADMIN'])"
          >批量设置角色</el-button
        >
        <el-button
          @click="addUser"
          size="small"
          icon="el-icon-plus"
          v-if="checkPermission(['USER_ADMIN'])"
          >新增用户</el-button
        >
      </div>
    </div>
    <div class="retention-table-wrapper">
      <div class="table-tool-box">
        <div class="tool-item">
          <span class="tool-label">用户姓名:</span>
          <span class="tool-content">
            <el-input
              style="width: 100%"
              v-model="tableFilters.name"
              clearable
              placeholder="用户姓名"
              @input="filterSearch"
            ></el-input>
          </span>
        </div>
        <div class="tool-item">
          <span class="tool-label">客户名称:</span>
          <el-select
            v-model="tableFilters.clientNameId"
            style="width: 100%"
            filterable
            clearable
            placeholder="客户名称"
            @change="filterSearch"
          >
            <template v-for="(item, index) in clientNames">
              <el-option
                :label="item.name"
                :value="item.id"
                :key="index"
              ></el-option>
            </template>
          </el-select>
        </div>
        <div class="tool-item">
          <span class="tool-label">角色:</span>
          <span class="tool-content">
            <el-select
              v-model="tableFilters.roles"
              style="width: 100%"
              filterable
              clearable
              placeholder="受理状态"
              @change="filterSearch"
            >
              <template v-for="(item, index) in rolesGroup">
                <el-option :label="item" :value="item" :key="index"></el-option>
              </template>
            </el-select>
          </span>
        </div>
        <div class="tool-item" style="flex: 2">
          <span class="tool-label">创建日期:</span>
          <span class="tool-content">
            <el-date-picker
              style="width: 100%"
              v-model="tableFilters.createdAt"
              type="daterange"
              @change="filterSearch"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </span>
        </div>
      </div>
      <el-table
        v-loading="tableLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        :data="tableData"
        border
        class="retention-table"
        style="width: 100%"
      >
        <el-table-column
          prop="disabled"
          label="账号状态"
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            <!-- <el-checkbox v-model="scope.row.enable" :label="scope.row.enable ? '启用' : '禁用'" border size="small"></el-checkbox> -->
            <span v-if="scope.row.disabled" class="text-info">
              <i class="el-icon-circle-close"></i> 禁用
            </span>
            <span v-if="!scope.row.disabled" class="text-success">
              <i class="el-icon-circle-check"></i> 启用
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="用户账号" align="center">
          <template slot-scope="scope">
            <span class="split-text" :title="scope.row.id">{{
              scope.row.id
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="用户姓名" align="center">
          <template slot-scope="scope">
            <span class="split-text" :title="scope.row.name">{{
              scope.row.name
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="departmentName" label="所属部门" align="center">
          <template slot-scope="scope">
            <span class="split-text" :title="scope.row.departmentName">{{
              scope.row.departmentName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="clientName" label="客户名称" align="center">
          <template slot-scope="scope">
            <span class="split-text" :title="scope.row.clientName">{{
              scope.row.clientName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" align="center">
          <template slot-scope="scope">
            <span class="text-split">{{ scope.row.createdAt | date }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="creatorName" label="创建人" align="center">
          <template slot-scope="scope">
            <span class="text-split" :title="scope.row.creatorName">{{
              scope.row.creatorName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="更新时间" align="center">
          <template slot-scope="scope">
            <span class="text-split">{{ scope.row.updatedAt | date }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="更新人" align="center">
          <template slot-scope="scope">
            <span class="text-split" :title="scope.row.updaterName">{{
              scope.row.updaterName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="control"
          align="center"
          label="操作"
          width="180"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              size="small"
              style="margin-right: 10px"
              @click="onEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="warning"
              class="control-btn"
              size="small"
              @click="showDetail(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagenation-wrapper">
        <!-- pc端显示 -->
        <el-pagination
          class="pagenation"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page + 1"
          :page-sizes="[10, 20, 40, 60, 80]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSizes"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      class="user-detail-dialog"
      :title="'用户：' + currentItem.id"
      :visible.sync="showUserDetailDialog"
      width="1000px"
    >
      <main>
        <DetailComponent
          v-if="showUserDetailDialog"
          :userId="currentItem.id"
          @deleteSuccess="deleteCallback"
          @unBoundSuccess="deleteCallback"
        />
      </main>
    </el-dialog>

    <el-dialog
      class="user-detail-dialog"
      :title="formType == 'edit' ? '编辑用户' : '新增用户'"
      :visible.sync="userEditDialog"
      :close-on-click-modal="false"
      width="1000px"
    >
      <main>
        <Edit
          v-if="userEditDialog"
          :userId="currentItem.id"
          :formType="formType"
          @cancel="userEditDialog = false"
          @onSuccess="onFormSubmitSuccess"
        />
      </main>
    </el-dialog>

    <el-dialog
      class="user-detail-dialog"
      title="批量设置角色"
      :visible.sync="userRolesSetDialog"
      :close-on-click-modal="false"
      width="1000px"
    >
      <main>
        <SetRoles v-if="userRolesSetDialog" @onSuccess="onFormSubmitSuccess" />
      </main>
    </el-dialog>
  </div>
</template>
<script>
import commonMenu from "@/components/menu";
import { mapMutations } from "vuex";
import { throttle } from "@/utils/app";
import qs from "qs";
import DetailComponent from "./components/Detail";
import Edit from "./components/Edit";
import SetRoles from "./components/SetRoles";
import { checkPermission } from "@/utils/auth";
export default {
  name: "retention",
  components: {
    commonMenu,
    DetailComponent,
    Edit,
    SetRoles,
  },
  data() {
    return {
      userRolesSetDialog: false,
      userEditDialog: false,
      showUserDetailDialog: false,
      size: 10,
      page: 0,
      totalPages: 0,
      totalSizes: 0,
      tableLoading: false,
      clientNames: [],
      rolesGroup: [],
      tableData: [],
      tableFilters: {
        name: "",
        clientNameId: "",
        createdAt: "",
        roles: "",
      },
      currentItem: {},
      formType: "add",
      selectGroups: [],
    };
  },
  computed: {
    isMobile() {
      return this.$store.state.app.isMobileMode;
    }
  },
  watch: {},
  created() {
    this.getTableData();
    this.getFilterOptions();
  },
  methods: {
    checkPermission,
    ...mapMutations({
      ToggleMobileSideBar: "app/ToggleMobileSideBar",
      ToggleToolBar: "app/ToggleToolBar",
      CloseMobileSideBar: "app/CloseMobileSideBar",
      CloseToolBar: "app/CloseToolBar",
    }),
    filterDataParams() {
      return {
        size: this.size,
        page: this.page,
        name: this.tableFilters.name,
        createdAt: this.tableFilters.createdAt,
        clientId: this.tableFilters.clientNameId,
        roles: this.tableFilters.roles,
      };
    },
    getFilterOptions() {
      this.$api
        .get(
          `/users/filters?${qs.stringify(this.filterDataParams(), {
            arrayFormat: "repeat",
          })}`
        )
        .then((res) => {
          if (res.status === 200 || res.status === 206) {
            let { clients, roles } = res.data;
            this.clientNames = clients;
            this.rolesGroup = roles;
          }
        })
        .catch((err) => {
          console.log(err.response);
          this.$message.error(err.response.data.message);
        });
    },
    getTableData() {
      this.tableLoading = true;
      this.$api
        .get(
          `/users?${qs.stringify(this.filterDataParams(), {
            arrayFormat: "repeat",
          })}`
        )
        .then((res) => {
          if (res.status === 200 || res.status === 206) {
            res.data.content.map((ele) => {
              ele.enable = !ele.disabled;
            });
            this.tableData = res.data.content;
            this.totalPages = res.data.totalPages;
            this.totalSizes = res.data.totalElements;
            this.tableLoading = false;
          }
        })
        .catch((err) => {
          console.log(err.response);
          this.$message.error(err.response.data.message);
        });
    },
    filterSearch() {
      // 移动端模式下需要关闭侧边栏
      if (this.isMobile) {
        this.CloseToolBar();
      }
      this.page = 0;
      this.getTableData();
      this.getFilterOptions();
    },
    addUser() {
      this.formType = "add";
      this.userEditDialog = true;
    },
    handleSizeChange(val) {
      this.page = 0;
      this.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page = val - 1;
      this.getTableData();
    },
    onFormSubmitSuccess() {
      this.page = 0;
      this.getTableData();
      this.userEditDialog = false;
      this.userRolesSetDialog = false;
    },
    showDetail(item) {
      this.currentItem = item;
      this.showUserDetailDialog = true;
    },
    onEdit(item) {
      this.currentItem = item;
      this.formType = "edit";
      this.userEditDialog = true;
    },
    deleteCallback() {
      this.showUserDetailDialog = false;
      this.page = 0;
      this.getTableData();
    },
    setRoles() {
      this.userRolesSetDialog = true;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/custom-variables.scss";
.retention-wrapper {
  overflow: hidden;
  .user-detail-dialog {
    main {
      background-color: #f1f1f1;
      width: 100%;
      height: 100%;
    }
    /deep/ {
      .el-dialog__header {
        text-align: left;
      }
      .el-dialog__body {
        padding: 0;
      }
    }
  }
  .retention-table-wrapper {
    width: 100%;
    padding-top: 30px;
    .table-tool-box {
      box-sizing: border-box;
      position: relative;
      margin-top: 0;
      margin-bottom: 30px;
      display: flex;
      justify-content: space-between;
      overflow: hidden;
      .tool-item {
        box-sizing: border-box;
        padding: 0 10px 0 0;
        flex: 1;
        max-width: 300px;
        display: flex;
        text-align: left;
        line-height: 40px;
        box-sizing: border-box;
        font-size: 0;
        &:last-child {
          padding: 0;
        }
        .tool-label {
          flex: 60px 0 0;
          width: 60px;
          text-align: left;
          font-size: 14px;
          font-weight: 450;
          color: #333;
          margin-right: 8px;
        }
        .tool-content {
          flex: 1;
          font-size: 14px;
          color: #333;
        }
      }
      .table-search {
        position: absolute;
        right: 0;
        bottom: 2px;
        width: 50px;
        height: 35px;
        line-height: 35px;
        font-size: 14px;
        text-align: center;
        color: #242424;
        border: 1px solid #929292;
        display: inline-block;
        transition: all 0.3s linear;
        &:hover {
          background-color: $theme_color;
          border: 1px solid $theme_color;
          color: #242424;
          cursor: pointer;
        }
      }
    }
    .retention-table {
      border: 1px solid #dbdbdb;
      .control-btn {
        margin: 5px auto;
        color: #333;
        background-color: $theme_color;
        border-color: $theme_color;
      }
      .split-text {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
  .pagenation-wrapper {
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    line-height: 55px;
    text-align: left;
    background-color: transparent;
    padding: 0px 5px 0 5px;
    overflow: hidden;
    border: 1px solid #dbdbdb;
    border-top: none;
    .pagenation {
      padding: 0;
      margin-top: 10px;
    }
    .pagenation-samll {
      text-align: center;
    }
  }
  .section-title {
    width: 100%;
    padding: 19px 0 26px 0;
    border-bottom: 1px solid #e0e0e0;
    text-align: left;
    font-size: 24px;
    display: flex;
    justify-content: space-between;
    .left {
      flex: 1;
      text-align: left;
    }
    .right {
      flex: 1;
      text-align: right;
    }
    .title-name {
      font-size: 24px;
      color: #4a4a4a;
      font-weight: bold;
      margin-left: 8px;
    }
  }
}
@media screen and(max-width:992px) {
  .retention-wrapper {
    padding: 0px 0px 20px 0px;
    .right {
      .retention-table-wrapper {
        padding: 0;
      }
    }
    .table-tool-box {
      display: block;
      .tool-item {
        width: 100%;
        padding: 10px 0;
        .tool-label {
          display: block;
          margin-bottom: 5px;
          color: #fff;
          text-align: left;
        }
        .tool-content {
          display: block;
          font-size: 14px;
          color: #333;
          .el-select {
            width: 100%;
          }
        }
      }
      .table-search {
        width: 100%;
        height: 45px;
        line-height: 45px;
        font-size: 15px;
        text-align: center;
        color: #333;
        background-color: $theme_color;
        display: block;
        margin-top: 12px;
        transition: all 0.3s linear;
      }
    }
  }
}
</style>
<style lang="scss">
.retention-wrapper {
  .table-tool-box {
    .el-input__inner {
      border: none;
      border-radius: 0px;
    }
  }
  .retention-table-wrapper {
    // 表格样式自定义
    .el-table {
      background-color: transparent;
      & ::before,
      & ::after {
        border-color: #dbdbdb;
      }
    }
    .el-table tr {
      background-color: transparent;
    }
    .el-table th {
      font-weight: normal;
      color: #000;
      background-color: #e7e7e7;
      border-color: #dbdbdb;
    }
    .el-table td {
      background-color: #f3f3f3;
      border-color: #dbdbdb;
    }
  }
  .pagenation-wrapper {
    // 页码列表的前后的按钮
    .el-pagination button {
      background-color: transparent;
    }
    .el-pagination button:disabled {
      background-color: transparent;
    }
    .el-pagination button:hover {
      color: #fff;
      background-color: #4c4948;
    }
    // 可选的页码列表
    .el-pager li {
      background-color: transparent;
    }
    .el-pager li:hover {
      color: #fff;
      background-color: #4c4948;
    }
    .el-pager li.active {
      color: #fff;
      background-color: #4c4948;
      cursor: default;
    }
    // 手动输入页数的输入框
    .el-pagination__editor.el-input .el-input__inner {
      background-color: transparent;
    }
    // 选择多少条每页的按钮
    .el-pagination .el-select .el-input .el-input__inner {
      background-color: transparent;
    }
  }
}
</style>



